<template>
    <div class="page-wrapper">
        <img alt="Roula Rouva Logo" class="logo" src="@/assets/img/rr-logo.png" />

        <router-link
            v-if="!isUserLoggedIn"
            :to="{name: 'login'}"
            class="el-button"
        >
            {{ $t("view.home.login") }}
        </router-link>
        <router-link
            v-if="isUserLoggedIn"
            :to="{name: 'dashboard'}"
            class="el-button"
        >
            {{ $t("view.home.goToDashboard") }}
        </router-link>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: "Home",
    head() {
        return {
            title: {
                inner: this.$t("view.home.home_title")
            }
        };
    },
    computed: {
        ...mapGetters("authentication", ["isUserLoggedIn"])
    }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
    display         : flex;
    flex-direction  : column;
    justify-content : center;
    align-items     : center;

    .logo {
        margin-bottom : 3rem;
        max-width     : 270px;
    }

    a {
        text-decoration : none;
    }
}
</style>
